/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import React, { Fragment as _, useContext } from 'react';
import { Box } from 'theme-ui';
import { interactionContext as InteractionContext } from './interactionContext';

const AssessmentIntroduction = ({ children, ...props }) => {
  const interactionContext = useContext<any>(InteractionContext);

  const [img, text] = children;

  const { includeMedia = true } = interactionContext.props;

  const imgProps = img?.props?.children[1]?.props;

  const {
    width: _imgWidth_,
    height: _imgHeight_,
    imgContainerHeight,
    src,
  } = imgProps;

  const isRaster =
    src &&
    ['png', 'jpg', 'jpeg', 'gif'].includes(
      src?.slice(src?.lastIndexOf('.') + 1).toLowerCase()
    );

  const width = _imgWidth_;
  const maxHeight = `${50 + imgContainerHeight}vh`;
  const aspectRatio = `${(_imgWidth_ - imgContainerHeight * 4) / _imgHeight_}`;

  return (
    <Box
      sx={{
        padding: '20px',
      }}
    >
      {includeMedia && (
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            margin: '20px 0',
            img: {
              //
            },
          }}
        >
          {!window.dev() && isRaster ? (
            <_>
              <div
                css={css({
                  width,
                  maxHeight,
                  aspectRatio,

                  img: {
                    // match the maxHeight of the container for always
                    // overriding the @media query maxHeight set more generally in the image component
                    maxHeight: `${maxHeight} !important`,
                  },
                })}
              >
                {img}
              </div>
            </_>
          ) : (
            img
          )}
        </Box>
      )}

      <Box
        sx={{
          marginBottom: '20px',
        }}
      >
        {text}
      </Box>
    </Box>
  );
};

export default AssessmentIntroduction;
